<template>
  <div class="question-wrap">
    <transition name="fade">
      <p class="question" :class="{'question_bottom': bottom}" v-show="show">{{text}}</p>
    </transition>
    <button type="button"
            @mouseenter="showText"
            @focus="showText"
            @blur="hideText"
            @mouseleave="hideText"
            class="question-btn">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4874 4.58337C11.0207 5.18337 11.2707 6.00003 11.1541 6.8667C10.9541 8.4667 9.7874 9.03337 8.75407 9.03337C8.70407 9.03337 8.67074 9.03337 8.67074 9.03337V9.43337C8.67074 9.80004 8.37074 10.1 8.00407 10.1C7.6374 10.1 7.3374 9.80004 7.3374 9.43337V8.90005C7.3374 8.35005 7.57074 7.70003 8.75407 7.70003C9.40407 7.70003 9.73741 7.3667 9.82074 6.70003C9.85407 6.48337 9.87074 5.90005 9.47074 5.46672C9.15408 5.11672 8.6374 4.93337 7.9374 4.93337C6.4374 4.93337 6.38741 5.9167 6.38741 6.0167C6.38741 6.38337 6.08741 6.68337 5.72074 6.68337C5.35408 6.68337 5.05408 6.38337 5.05408 6.0167C5.05408 5.35004 5.57073 3.60004 7.9374 3.60004C9.32073 3.60004 10.0874 4.13337 10.4874 4.58337ZM7.95406 10.6667C7.73739 10.6667 7.52073 10.75 7.37073 10.9167C7.22073 11.0667 7.12073 11.2834 7.12073 11.5C7.12073 11.7167 7.20406 11.9334 7.37073 12.0834C7.52073 12.2334 7.73739 12.3334 7.95406 12.3334C8.17073 12.3334 8.38739 12.25 8.53739 12.0834C8.68739 11.9334 8.78739 11.7167 8.78739 11.5C8.78739 11.2834 8.70406 11.0667 8.53739 10.9167C8.40406 10.7667 8.18739 10.6667 7.95406 10.6667ZM15.6707 8.00004C15.6707 12.2334 12.2374 15.6667 8.00407 15.6667C3.77074 15.6667 0.337402 12.2334 0.337402 8.00004C0.337402 3.76671 3.77074 0.333374 8.00407 0.333374C12.2374 0.333374 15.6707 3.76671 15.6707 8.00004ZM14.3374 8.00004C14.3374 4.50004 11.5041 1.66671 8.00407 1.66671C4.50407 1.66671 1.67074 4.50004 1.67074 8.00004C1.67074 11.5 4.50407 14.3334 8.00407 14.3334C11.5041 14.3334 14.3374 11.5 14.3374 8.00004Z" fill="#00527F"/>
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'questionBtn',
    props: {
      text: {
        type: String,
        default: ''
      },
      bottom: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      showText() {
        this.show = true
      },
      hideText() {
        this.show = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .question-wrap {
    position: relative;

    .question {
      position: absolute;
      width: 130px;
      background: #D7E3EA;
      left: calc(50% - 65px);
      bottom: calc(100% + 7px);
      font-family: $mm;
      font-size: 12px;
      letter-spacing: 0.25px;
      text-align: center;
      padding: 5px;
      border-radius: 2px;

      &::before {
        content: '';
        position: absolute;
        width: 11px;
        height: 11px;
        background: #D7E3EA;
        transform: rotate(45deg);
        left: 43%;
        bottom: -5px
      }
    }

    .question_bottom {
      bottom: auto;
      top: calc(100% + 7px);
      left: calc(50% - 85px);

      &::before {
        bottom: auto;
        top: -5px;
        left: 57%;
      }
    }
  }

  button {
    padding-top: 4px;
    opacity: 0.5;
    transition: $anim;
    position: relative;

    &:hover, &:focus {
      opacity: 1;
    }
  }
</style>
